import * as React from "react"
import cn from "classnames"
import injectSheet from "react-jss"
import compose from "recompose/compose"
import { withi18n } from "@/helpers/hoc/withi18n"
import { Text } from "@xingternal/360-components"

const i18n = {
  findOutMore: "360_RECRUITER_INSIGHTS_FECING_LINK01",
}

const styles = {
  fencedAction: {
    composes:
      "cursor-pointer p0 m0 border-none onlyfy-link outline-none text-align-left",
    background: "none",
  },
}

const FindOutMore = ({ classes, className, onClick, findOutMore }) => (
  <button onClick={onClick} className={cn(classes.fencedAction, className)}>
    <Text size={13} bold>
      {findOutMore}
    </Text>
  </button>
)

const enhance = compose(withi18n(i18n), injectSheet(styles))

export const EnhancedFindOutMore = enhance(FindOutMore)
export default FindOutMore
